import FormField from './FormField';

export default class FormFieldRadioButton extends FormField
{

}
